.round-element {
  --size-extra-extra-small: 24px;
  --size-extra-small: 32px;
  --size-small: 56px;
  --size-medium: 80px;
  --size-large: 125px;
  --icon-font-size-extra-extra-small: 10px;
  --icon-font-size-extra-small: 16px;
  --icon-font-size-small: 24px;
  --icon-font-size-large: 32px;

  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.small {
  width: var(--size-small);
  height: var(--size-small);
  font-size: var(--icon-font-size-small);
}

.medium {
  width: var(--size-medium);
  height: var(--size-medium);
  font-size: var(--icon-font-size-large);
}

.large {
  width: var(--size-large);
  height: var(--size-large);
  font-size: var(--icon-font-size-large);
}

.extra-small {
  width: var(--size-extra-small);
  height: var(--size-extra-small);
  font-size: var(--icon-font-size-extra-small);
}

.extra-extra-small {
  width: var(--size-extra-extra-small);
  height: var(--size-extra-extra-small);
  font-size: var(--icon-font-size-extra-extra-small);
}

.success {
  background-color: #52c41a;
}

.default {
  background-color: var(--rc-theme-color-surface-subtle);
}
